import type { UserChatMessage as UserChatMessageModel } from '../../../../public-api-contracts/src/models/chat/ChatMessage';
import './UserChatMessage.less';

export type UserChatMessageProps = {
    userChatMessage: UserChatMessageModel;
};

const UserChatMessage = ({ userChatMessage }: UserChatMessageProps) => (
    <div className={`bri-UserChatMessage bri-DisplayFont`}>
        {userChatMessage.content.text}
    </div>
);

export default UserChatMessage;
